import React, {useState} from 'react';
import {useGet} from "../../network/useGet";
import NetworkWrapper from "../NetworkWrapper";
import BaseTableView from "./BaseTableView";
import BaseForm from "./BaseForm";
import {deleteFromHub} from "../../network/actions";



function BasicResource(props) {
    const [ reloadTriggerCount, setReloadTriggerCount ] = useState(1);
    const { isLoading, data, error } = useGet(props.dataUrl, reloadTriggerCount);
    const [ showForm, setShowForm ] = useState(false);
    const [ selectedId, setSelectedId ] = useState(null);





    return (
        <NetworkWrapper isLoading={isLoading} error={error}>
            {data &&
            <div>
                <div style={{display: "grid", gridTemplateColumns: "3fr minmax(250px, 1fr)"}}>
                    <BaseTableView
                        addNewButton={props.addNewButton}
                        downloadExport={props.downloadExport}
                        exportUrl={props.exportUrl}
                        exportFileName={props.exportFileName}
                        data={data}
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        setShowForm={setShowForm}
                        tableFields={props.tableFields}
                        extraElements={props.extraElements}
                        globalFilter={props.globalFilter}
                    />

                    <div className="ml-4">
                       <BaseForm
                           showForm={showForm}
                           entityUrl={props.entityUrl}
                           dropdownDataUrls={props.dropdownDataUrls}
                           entryId={selectedId}
                           formFields={props.formFields}
                           submitUrl={props.submitUrl}
                           onSuccess={() => {
                               setReloadTriggerCount(prevTriggerCount => prevTriggerCount + 1);
                               setSelectedId(null);
                               setShowForm(false);
                           }}
                           onClose={() => {
                               setSelectedId(null);
                               setShowForm(false);
                           }}
                           onDelete={props.allowDelete ?
                               async () => {
                                   await deleteFromHub(`${props.entityUrl}/${selectedId}`);
                                   setReloadTriggerCount(prevCount => prevCount + 1);
                                   setSelectedId(null);
                                   setShowForm(false);
                               } :
                               null
                           }
                           includeIdInUrlOnUpdate={props.includeIdInUrlOnUpdate}
                       />
                    </div>

                </div>
            </div>
            }
        </NetworkWrapper>
    );
}

export default BasicResource;